import React, { useEffect, useState } from 'react'
import { c, t } from 'ttag'
import { ReactComponent as AcceptedIcon } from '../../assets/v2/icons/checked-circle-green.svg'
import { ReactComponent as ErrorIcon } from '../../assets/v2/icons/error.svg'
import { FormGroup } from '@material-ui/core'
import { darkSuccess, red } from '../../styles/material-ui-theme-v2'
import { PasswordPolicy } from '../../services/api.types'
import makeStyles from '@material-ui/core/styles/makeStyles'

export interface IStateProps {
  policy: PasswordPolicy
  password: string
  onPolicyChange: (valid: boolean) => void
}

const useStyles = makeStyles((theme) => ({
  formGroup: { marginBottom: '16px', fontSize: '0.75rem' },
  intro: { marginBottom: '5px' },
  rule: { marginBottom: '4px', fontWeight: 500 },
  icon: { position: 'relative', top: '-1px', width: 12, height: 12 },
  ok: { color: darkSuccess },
  error: { color: red },
}))

export default function YumPasswordPolicy(props: IStateProps) {
  const { policy, password, onPolicyChange } = props
  const classes = useStyles()

  const [showPolicyOne, setShowPolicyOne] = useState(policy === PasswordPolicy.POLICY_1)
  const [ruleOneOK, setRuleOneOK] = useState(true)
  const [ruleTwoOK, setRuleTwoOK] = useState(false)
  const [ruleThreeOK, setRuleThreeOK] = useState(false)
  const [ruleFourOK, setRuleFourOK] = useState(false)

  useEffect(() => {
    if (showPolicyOne) {
      const UPPERCASE_PATTERN = /[A-Z]/
      const LOWERCASE_PATTERN = /[a-z]/
      const DIGIT_PATTERN = /[0-9]/
      const SPECIAL_CHAR_PATTERN = /[^A-Za-z0-9]/

      let criteriaMet = 0
      if (UPPERCASE_PATTERN.test(password)) {
        criteriaMet++
        setRuleOneOK(true)
      } else {
        setRuleOneOK(false)
      }
      if (LOWERCASE_PATTERN.test(password)) {
        criteriaMet++
        setRuleTwoOK(true)
      } else {
        setRuleTwoOK(false)
      }
      if (DIGIT_PATTERN.test(password)) {
        criteriaMet++
        setRuleThreeOK(true)
      } else {
        setRuleThreeOK(false)
      }
      if (SPECIAL_CHAR_PATTERN.test(password)) {
        criteriaMet++
        setRuleFourOK(true)
      } else {
        setRuleFourOK(false)
      }
      onPolicyChange(criteriaMet >= 3)
    }
  }, [password])

  return showPolicyOne ? (
    <FormGroup className={classes.formGroup}>
      <div className={classes.intro}>
        {t`Password must contain at least three of the following four characteristics:`}
      </div>
      <div className={[classes.rule, ruleOneOK ? classes.ok : classes.error].join(' ')}>
        {ruleOneOK ? <AcceptedIcon className={classes.icon} /> : <ErrorIcon className={classes.icon} />}
        {` `}
        {c('password requirements').t`One uppercase character`}
      </div>
      <div className={[classes.rule, ruleTwoOK ? classes.ok : classes.error].join(' ')}>
        {ruleTwoOK ? <AcceptedIcon className={classes.icon} /> : <ErrorIcon className={classes.icon} />}
        {` `}
        {c('password requirements').t`One lowercase character`}
      </div>
      <div className={[classes.rule, ruleThreeOK ? classes.ok : classes.error].join(' ')}>
        {ruleThreeOK ? <AcceptedIcon className={classes.icon} /> : <ErrorIcon className={classes.icon} />}
        {` `}
        {c('password requirements').t`One digit`}
      </div>
      <div className={[classes.rule, ruleFourOK ? classes.ok : classes.error].join(' ')}>
        {ruleFourOK ? <AcceptedIcon className={classes.icon} /> : <ErrorIcon className={classes.icon} />}
        {` `}
        {c('password requirements').t`One special character (symbol)`}
      </div>
    </FormGroup>
  ) : null
}
